<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  page: {
    titleTemplate(title) {
      return appConfig.title;
    },
  },

  watch: {
    $route(to, from) {
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
  <div id="app" class="notranslate" translate="no">
    <RouterView />
  </div>
</template>
